import { render } from "./a-settings.vue?vue&type=template&id=7497be90&scoped=true"
import script from "./a-settings.vue?vue&type=script&lang=js"
export * from "./a-settings.vue?vue&type=script&lang=js"

import "./a-settings.vue?vue&type=style&index=0&id=7497be90&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7497be90"]])

export default __exports__